exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html, body {\n  height: 100%;\n  font-family: Arial, Helvetica, sans-serif; }\n\n.sidenav .nav-group {\n  margin-top: 0; }\n\n.header .user-picture {\n  border-radius: 50%;\n  height: 35px;\n  width: 35px;\n  margin: 5px; }\n\n.sidenav {\n  min-width: 0; }\n\nbutton:focus {\n  outline: none; }\n\n.main-container .content-container .content-area {\n  padding: 0;\n  position: relative; }\n  .main-container .content-container .content-area section {\n    margin: 24px; }\n    .main-container .content-container .content-area section.no-margin {\n      margin: 0; }\n  .main-container .content-container .content-area header {\n    color: inherit;\n    background: #fefefe;\n    border-bottom: 1px solid #ddd;\n    height: auto;\n    padding: 0 24px 24px 24px;\n    display: block; }\n\n.flex-nav-link .nav-text {\n  display: flex;\n  align-items: center; }\n  .flex-nav-link .nav-text > span {\n    flex: 1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/app.component.scss
// module id = gwAW
// module chunks = 6